import { render, staticRenderFns } from "./EdgeCard.vue?vue&type=template&id=593c7a4f&"
import script from "./EdgeCard.vue?vue&type=script&lang=js&"
export * from "./EdgeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593c7a4f')) {
      api.createRecord('593c7a4f', component.options)
    } else {
      api.reload('593c7a4f', component.options)
    }
    module.hot.accept("./EdgeCard.vue?vue&type=template&id=593c7a4f&", function () {
      api.rerender('593c7a4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/library/cards/EdgeCard.vue"
export default component.exports